import Marquee from "react-fast-marquee";
import { Star } from "@phosphor-icons/react";
import { useI18n } from "@/context/I18nContext";

const REVIEWS_EN = [
    { author: "Maria G.", text: "Authentic and absolutely delicious. Best Cubano in CT." },
    { author: "Tony R.", text: "Huge portions, great prices and the chimi sauce is dangerous." },
    { author: "Jada P.", text: "Cozy atmosphere, family vibes, the pernil is unreal." },
    { author: "Luis A.", text: "My weekly mangú stop. Real Dominican flavor." },
    { author: "Brittany K.", text: "5 stars. Empanadas hot, fresh and crispy every time." },
    { author: "Carlos M.", text: "Felt like home. Service is so warm and the food slaps." },
];

const REVIEWS_ES = [
    { author: "María G.", text: "Auténtico y delicioso. El mejor Cubano de Connecticut." },
    { author: "Tony R.", text: "Porciones enormes, buen precio y la salsa del chimi es peligrosa." },
    { author: "Jada P.", text: "Ambiente acogedor, vibras de familia y el pernil es de otro mundo." },
    { author: "Luis A.", text: "Mi parada semanal de mangú. Sabor dominicano real." },
    { author: "Brittany K.", text: "Cinco estrellas. Empanadas calientes, frescas y crujientes." },
    { author: "Carlos M.", text: "Me sentí como en casa. Excelente servicio y comida." },
];

export default function Reviews() {
    const { t, lang } = useI18n();
    const data = lang === "en" ? REVIEWS_EN : REVIEWS_ES;
    return (
        <section id="reviews" data-testid="reviews" className="bg-accent text-accent-foreground py-20 md:py-28 overflow-hidden">
            <div className="mx-auto w-full max-w-7xl px-4 md:px-8 mb-12">
                <div className="flex items-end justify-between flex-wrap gap-4">
                    <div>
                        <p className="text-xs font-bold uppercase tracking-[0.25em] text-secondary">
                            {t("reviews.rating")}
                        </p>
                        <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl mt-2 max-w-2xl">
                            {t("reviews.title")}
                        </h2>
                    </div>
                    <div className="flex items-center gap-1">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Star key={i} size={28} weight="fill" className="text-secondary" />
                        ))}
                        <span className="ml-2 font-display font-black text-3xl">5.0</span>
                    </div>
                </div>
            </div>

            <Marquee speed={45} pauseOnHover gradient={false}>
                {data.concat(data).map((r, i) => (
                    <article
                        key={i}
                        data-testid={`review-${i}`}
                        className="mx-3 w-[320px] md:w-[420px] shrink-0 bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur"
                    >
                        <div className="flex gap-1 mb-3">
                            {Array.from({ length: 5 }).map((_, j) => (
                                <Star key={j} size={16} weight="fill" className="text-secondary" />
                            ))}
                        </div>
                        <p className="text-base md:text-lg leading-relaxed">"{r.text}"</p>
                        <p className="mt-4 text-xs uppercase tracking-widest text-white/60">— {r.author}</p>
                    </article>
                ))}
            </Marquee>
        </section>
    );
}
